/* eslint-disable  */

// Stub for convert functionality
export const convertDollarsToCents = (dollars: number): number => {
  return Math.round(dollars * 100);
};

export const convertCentsToDollars = (cents: number): number => {
  return cents / 100;
};

// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
//
// To parse this data:
//
//   import { Convert, ServiceLine } from "./file";
//
//   const serviceLine = Convert.toServiceLine(json);
//   const cms1500 = Convert.toCms1500(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.

// WARNING - this file was generated, do not edit it manually via QuickType

import { Cms1500 } from './cms_1500';
import { ServiceLine } from './service_line';

export class Convert {
  public static toServiceLine(json: string): ServiceLine {
    return cast(JSON.parse(json), r('ServiceLine'));
  }

  public static toCms1500(json: string): Cms1500 {
    return cast(JSON.parse(json), r('Cms1500'));
  }

  public static serviceLineToJson(value: ServiceLine): string {
    return JSON.stringify(uncast(value, r('ServiceLine')), null, 2);
  }
}

function invalidValue(typ: any, val: any, key: any, parent: any = ''): never {
  const prettyTyp = prettyTypeName(typ);
  const parentText = parent ? ` on ${parent}` : '';
  const keyText = key ? ` for key "${key}"` : '';
  throw Error(
    `Invalid value${keyText}${parentText}. Expected ${prettyTyp} but got ${JSON.stringify(val)}`
  );
}

function prettyTypeName(typ: any): string {
  if (Array.isArray(typ)) {
    if (typ.length === 2 && typ[0] === undefined) {
      return `an optional ${prettyTypeName(typ[1])}`;
    } else {
      return `one of [${typ
        .map((a) => {
          return prettyTypeName(a);
        })
        .join(', ')}]`;
    }
  } else if (typeof typ === 'object' && typ.literal !== undefined) {
    return typ.literal;
  } else {
    return typeof typ;
  }
}

function jsonToJSProps(typ: any): any {
  if (typ.jsonToJS === undefined) {
    const map: any = {};
    typ.props.forEach((p: any) => (map[p.json] = { key: p.js, typ: p.typ }));
    typ.jsonToJS = map;
  }
  return typ.jsonToJS;
}

function jsToJSONProps(typ: any): any {
  if (typ.jsToJSON === undefined) {
    const map: any = {};
    typ.props.forEach((p: any) => (map[p.js] = { key: p.json, typ: p.typ }));
    typ.jsToJSON = map;
  }
  return typ.jsToJSON;
}

function transform(val: any, typ: any, getProps: any, key: any = '', parent: any = ''): any {
  function transformPrimitive(typ: string, val: any): any {
    if (typeof typ === typeof val) return val;
    return invalidValue(typ, val, key, parent);
  }

  function transformUnion(typs: any[], val: any): any {
    // val must validate against one typ in typs
    const l = typs.length;
    for (let i = 0; i < l; i++) {
      const typ = typs[i];
      try {
        return transform(val, typ, getProps);
      } catch (_) {}
    }
    return invalidValue(typs, val, key, parent);
  }

  function transformEnum(cases: string[], val: any): any {
    if (cases.indexOf(val) !== -1) return val;
    return invalidValue(
      cases.map((a) => {
        return l(a);
      }),
      val,
      key,
      parent
    );
  }

  function transformArray(typ: any, val: any): any {
    // val must be an array with no invalid elements
    if (!Array.isArray(val)) return invalidValue(l('array'), val, key, parent);
    return val.map((el) => transform(el, typ, getProps));
  }

  function transformDate(val: any): any {
    if (val === null) {
      return null;
    }
    const d = new Date(val);
    if (isNaN(d.valueOf())) {
      return invalidValue(l('Date'), val, key, parent);
    }
    return d;
  }

  function transformObject(props: { [k: string]: any }, additional: any, val: any): any {
    if (val === null || typeof val !== 'object' || Array.isArray(val)) {
      return invalidValue(l(ref || 'object'), val, key, parent);
    }
    const result: any = {};
    Object.getOwnPropertyNames(props).forEach((key) => {
      const prop = props[key];
      const v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
      result[prop.key] = transform(v, prop.typ, getProps, key, ref);
    });
    Object.getOwnPropertyNames(val).forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(props, key)) {
        result[key] = transform(val[key], additional, getProps, key, ref);
      }
    });
    return result;
  }

  if (typ === 'any') return val;
  if (typ === null) {
    if (val === null) return val;
    return invalidValue(typ, val, key, parent);
  }
  if (typ === false) return invalidValue(typ, val, key, parent);
  let ref: any = undefined;
  while (typeof typ === 'object' && typ.ref !== undefined) {
    ref = typ.ref;
    typ = typeMap[typ.ref];
  }
  if (Array.isArray(typ)) return transformEnum(typ, val);
  if (typeof typ === 'object') {
    return typ.hasOwnProperty('unionMembers')
      ? transformUnion(typ.unionMembers, val)
      : typ.hasOwnProperty('arrayItems')
        ? transformArray(typ.arrayItems, val)
        : typ.hasOwnProperty('props')
          ? transformObject(getProps(typ), typ.additional, val)
          : invalidValue(typ, val, key, parent);
  }
  // Numbers can be parsed by Date but shouldn't be.
  if (typ === Date && typeof val !== 'number') return transformDate(val);
  return transformPrimitive(typ, val);
}

function cast<T>(val: any, typ: any): T {
  return transform(val, typ, jsonToJSProps);
}

function uncast<T>(val: T, typ: any): any {
  return transform(val, typ, jsToJSONProps);
}

function l(typ: any) {
  return { literal: typ };
}

function a(typ: any) {
  return { arrayItems: typ };
}

function u(...typs: any[]) {
  return { unionMembers: typs };
}

function o(props: any[], additional: any) {
  return { props, additional };
}

function m(additional: any) {
  return { props: [], additional };
}

function r(name: string) {
  return { ref: name };
}

const typeMap: any = {
  ServiceLine: o(
    [
      { json: 'id', js: 'id', typ: u(undefined, '') },
      { json: 'created_at', js: 'createdAt', typ: u(undefined, Date) },
      { json: 'updated_at', js: 'updatedAt', typ: u(undefined, Date) },
      { json: 'deleted_at', js: 'deletedAt', typ: u(undefined, Date) },
      {
        json: 'cpt_code_healthie_created_at',
        js: 'cptCodeHealthieCreatedAt',
        typ: u(undefined, Date)
      },
      { json: 'cpt_code_code', js: 'cptCodeCode', typ: u(undefined, null, '') },
      {
        json: 'cpt_code_description',
        js: 'cptCodeDescription',
        typ: u(undefined, null, '')
      },
      {
        json: 'cpt_code_display_name',
        js: 'cptCodeDisplayName',
        typ: u(undefined, null, '')
      },
      {
        json: 'cpt_code_healthie_id',
        js: 'cptCodeHealthieid',
        typ: u(undefined, 0)
      },
      {
        json: 'cpt_code_last_fee_in_cents',
        js: 'cptCodeLastFeeInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'cpt_code_healthie_updated_at',
        js: 'cptCodeHealthieUpdatedAt',
        typ: u(undefined, Date)
      },
      {
        json: 'healthie_created_at',
        js: 'healthieCreatedAt',
        typ: u(undefined, Date)
      },
      { json: 'epsdt', js: 'epsdt', typ: u(undefined, '') },
      {
        json: 'family_planning_service',
        js: 'familyPlanningService',
        typ: u(undefined, true)
      },
      { json: 'fee_in_cents', js: 'feeInCents', typ: u(undefined, 0) },
      { json: 'healthie_id', js: 'healthieId', typ: u(undefined, 0) },
      { json: 'mod1', js: 'mod1', typ: u(null, '') },
      { json: 'mod2', js: 'mod2', typ: u(null, '') },
      { json: 'mod3', js: 'mod3', typ: u(null, '') },
      { json: 'mod4', js: 'mod4', typ: u(null, '') },
      { json: 'service_date', js: 'serviceDate', typ: u(undefined, Date) },
      { json: 'units', js: 'units', typ: u(undefined, 0) },
      {
        json: 'healthie_updated_at',
        js: 'healthieUpdatedAt',
        typ: u(undefined, Date)
      },
      { json: 'cms1500', js: 'cms1500', typ: u(undefined, '') },
      { json: 'cpt_code', js: 'cptCode', typ: u(undefined, null, '') },
      {
        json: 'first_sent_to_clearinghouse_at',
        js: 'firstSentToClearinghouseAt',
        typ: u(undefined, null, Date)
      },
      {
        json: 'last_sent_to_clearinghouse_at',
        js: 'lastSentToClearinghouseAt',
        typ: u(undefined, null, Date)
      },
      {
        json: 'billing_items',
        js: 'billing_items',
        typ: a(r('BillingItemElement'))
      }
    ],
    false
  ),
  BillingItemElement: o(
    [
      { json: 'id', js: 'id', typ: '' },
      { json: 'encounter_id', js: 'encounter_id', typ: '' },
      { json: 'encounter_type', js: 'encounter_type', typ: '' },
      { json: 'service_at', js: 'service_at', typ: Date },
      { json: 'service_type', js: 'service_type', typ: '' },
      { json: 'service_class', js: 'service_class', typ: '' },
      { json: 'person_name', js: 'person_name', typ: '' }
    ],
    false
  ),
  Cms1500: o(
    [
      { json: 'id', js: 'id', typ: u(undefined, '') },
      {
        json: 'cms1500cptcodes',
        js: 'cms1500Cptcodes',
        typ: u(undefined, a(r('ServiceLine')))
      },
      { json: 'created_at', js: 'createdAt', typ: u(undefined, Date) },
      { json: 'updated_at', js: 'updatedAt', typ: u(undefined, Date) },
      { json: 'deleted_at', js: 'deletedAt', typ: u(undefined, Date) },
      {
        json: 'patient_full_name',
        js: 'patientFullName',
        typ: u(undefined, null, '')
      },
      {
        json: 'patient_birthday',
        js: 'patientBirthday',
        typ: u(undefined, Date)
      },
      {
        json: 'patient_jurisdiction',
        js: 'patientJurisdiction',
        typ: u(undefined, null, '')
      },
      {
        json: 'rendering_provider_name_with_title',
        js: 'renderingProviderNameWithTitle',
        typ: u(undefined, null, '')
      },
      {
        json: 'additional_text',
        js: 'additionalText',
        typ: u(undefined, null, '')
      },
      {
        json: 'healthie_created_at',
        js: 'healthieCreatedAt',
        typ: Date
      },
      { json: 'date_of_service', js: 'dateOfService', typ: u(undefined, Date) },
      { json: 'healthie_id', js: 'healthieId', typ: 0 },
      {
        json: 'nineteen_reserved',
        js: 'nineteenReserved',
        typ: u(undefined, null, '')
      },
      {
        json: 'orig_ref_number',
        js: 'origRefNumber',
        typ: u(undefined, null, '')
      },
      {
        json: 'patient_account_num',
        js: 'patientAccountNum',
        typ: u(undefined, null, '')
      },
      {
        json: 'primary_plan_name',
        js: 'primaryPlanName',
        typ: u(undefined, null, '')
      },
      {
        json: 'resubmission_code',
        js: 'resubmissionCode',
        typ: u(undefined, null, '')
      },
      { json: 'status', js: 'status', typ: u(undefined, '') },
      { json: 'staff', js: 'staff', typ: u(undefined, '') },
      { json: 'patient', js: 'patient', typ: u(undefined, '') },
      {
        json: 'rendering_provider',
        js: 'renderingProvider',
        typ: u(undefined, null, '')
      },
      { json: 'policies', js: 'policies', typ: 'any' },
      {
        json: 'first_sent_to_clearinghouse_at',
        js: 'firstSentToClearinghouseAt',
        typ: u(undefined, null, Date)
      },
      {
        json: 'last_sent_to_clearinghouse_at',
        js: 'lastSentToClearinghouseAt',
        typ: u(undefined, null, Date)
      },
      {
        json: 'healthie_amount_paid_in_cents',
        js: 'healthieAmountPaidInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'healthie_amount_reimbursed_in_cents',
        js: 'healthieAmountReimbursedInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'healthie_client_responsibility_in_cents',
        js: 'healthieClientResponsibilityInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'healthie_copay_still_owed_in_cents',
        js: 'healthieCopayStillOwedInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'healthie_copay_in_cents',
        js: 'healthieCopayInCents',
        typ: u(undefined, null, 0)
      },
      {
        json: 'candid_encounter_ids',
        js: 'candidEncounterIds',
        typ: u(undefined, a(''))
      }
    ],
    false
  )
};
